module.exports = __webpack_public_path__ + "media/images/about-bg-a1c70c055e59fcad893e2e304982aa3d.png";